import { render } from "./PaymentRequest.vue?vue&type=template&id=2c2bea3b&scoped=true"
import script from "./PaymentRequest.vue?vue&type=script&lang=js"
export * from "./PaymentRequest.vue?vue&type=script&lang=js"

import "./PaymentRequest.vue?vue&type=style&index=0&id=2c2bea3b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/veins_checkin_vue/veins_checkin_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2bea3b"]])

export default __exports__